module.exports = __webpack_public_path__ + "img/label.7fd101f7.png";